<div class="card-template-1" [ngStyle]="{'background': bgColor}">
    <div class="flex sm:flex-row mobile:flex-col main-row">
        <a class="thumbnail" type="button" appClick [routerLink]="routerLinkString()">
            <div class="img-container">
                <img [src]="image" loading="lazy" [alt]="product?.name.en">
            </div>
        </a>

        <div class="details">
            <div>
                <a class="text-center font-bold" [routerLink]="((product?.sector?.seo?.slug) ? ['/sector', product?.sector?.seo?.slug] : ['/']).concat(['vendor', product?.companyData?.seo?.slug])">
                    <div class="flex flex-row items-center vendor">
                        <div class="vendor-name">{{product?.companyData?.name?.en}}</div>
                        <mat-icon [fontIcon]="isRTL?'arrow_backward':'arrow_forward'"></mat-icon>
                    </div>
                </a>
            </div>
            <div class="tag">
                <span *ngIf="product?.realEstate?.displayPrice?.propertyType" class="capitalize">
                    For {{product?.realEstate?.displayPrice?.propertyType}}
                </span>
            </div>

            <div appClick [routerLink]="routerLinkString()" class="name line-clamp-2">
                {{product?.name?.en}}
            </div>

            <div class="mt-auto">
                <div class="property-price">
                    <ng-container *ngIf="product?.realEstate?.displayPrice">
                        <div class="flex flex-row price-range items-center font-bold">
                            <div>
                                <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'exact'">
                                    <span class="price-color">{{product?.realEstate?.displayPrice?.price|currencyFormat: null : null :'0.0-3'}}</span>
                                </ng-container>
                                <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'range'">
                                    <span class="price-color">{{product?.realEstate?.displayPrice?.priceRange?.min|currencyFormat: null : null :'0.0-3'}}
                                        -
                                        {{product?.realEstate?.displayPrice?.priceRange?.max|currencyFormat: null : null :'0.0-3'}}</span>
                                </ng-container>
                                <ng-container *ngIf="product?.realEstate?.displayPrice?.priceType == 'from'">
                                    <span class="price-color">{{"starting_from"|translate}}
                                        {{product?.realEstate?.displayPrice?.price|currencyFormat: null : null :'0.0-3' }}</span>
                                </ng-container>
                            </div>
                            <div class="rent" *ngIf="product?.realEstate?.displayPrice?.propertyType =='rent' && product.realEstate?.displayPrice?.rentType">
                                / {{product?.realEstate?.displayPrice?.rentType|uppercase}}
                            </div>
                        </div>
                        <label *ngIf="product.realEstate?.displayPrice?.priceLabel">{{translateHelper.localize(product.realEstate?.displayPrice?.priceLabel)}}</label>
                    </ng-container>
                    <ng-container *ngIf="!product?.realEstate?.displayPrice">
                        {{product?.price|currencyFormat}}
                    </ng-container>
                </div>

                <div class="flex flex-wrap properties-list">
                    <ng-container *ngFor="let property of product?.subtype?.properties">
                        <div *ngIf="property.name?.en == 'Bedrooms' || property.name?.en == 'Bathrooms' || property.name?.en == 'Property size'" class="flex flex-row property items-center">
                            <ng-container *ngIf="property.iconImg">
                                <img [src]="property.iconImg.url" class="me-2 iconImg">
                            </ng-container>

                            <ng-container *ngIf="!property.iconImg">
                                <mat-icon class="ltr:mr-2 rtl:ms-2" [inline]="true">{{property.icon}} </mat-icon>
                            </ng-container>
                            {{(property.value?.name)?translateHelper.localize(property.value?.name):property.value}}

                        </div>

                    </ng-container>
                </div>
            </div>

            <!-- <div class="product-property-properties">
                <ng-container *ngFor="let property of product?.subtype?.properties">
                    <div class="property-name  font-bold">
                        {{property?.name?.en}} :
                    </div>
                    <span class="ms-2"><i [class]="property.icon"> </i></span>
                    <div class="property-value ms-2">
                        <ng-container *ngIf="property.type=='checkbox' && property.value">
                            <span *ngIf="property.value=='true'"><i class="fas fa-check"></i></span>
                            <span *ngIf="property.value=='false'"><i class="fas fa-times"></i></span>
                        </ng-container>
                        <ng-container *ngIf="property.type=='list' && property.value">
                            <span>{{property.value?.name?.en}}</span>
                        </ng-container>
                    </div>

                </ng-container>
            </div -->
        </div>


    </div>